import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BannerAnalysisDataService {
  private bannerAnalysisSubject = new BehaviorSubject<any>({
    bannerName: '',
    marketName: '',
    salesSqft: null,
    salesVolume: null,
    storeCount: null
  });
  public bannerAnalysis$ = this.bannerAnalysisSubject.asObservable();

  updateBannerAnalysis(data: any): void {
    const current = this.bannerAnalysisSubject.value;
    this.bannerAnalysisSubject.next({ ...current, ...data });
  }

  getBannerAnalysis(): any {
    return this.bannerAnalysisSubject.value;
  }
}